import React,{useState,useEffect} from 'react'
import {useMailChimp,Status} from './MailChimpSubscribeHook';
import { useTranslation } from 'react-i18next';
import { DateCellStyling,ContentCellStyling } from './BiogTableStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';

export default function MailChimpSubscribe() {
  const [form, setForm] = useState({firstName: '', lastName: '', email: ''})
  const {subscribe, status, error, value} = useMailChimp('https://noravest.us13.list-manage.com/subscribe/post?u=fd3e620d4b8a08ac7bb3c0087&amp;id=50628c8882')
  const { t } = useTranslation('common');

  useEffect(() => {
    setForm({firstName: '', lastName: '', email: ''});
  }, []);

  const handleInputChange = event => {
    const target = event.target;
    const name = target.id;
    const value = target.value;

    setForm(form => ({
      ...form,
      [name]: value,
    }));
  }

  const Loading = () => {
    return (
      <div>Loading</div>
    )
  }

  const Error = () => {
    return (
      <div>Error</div>
    )
  }

  const Success = (props) => {
    return (
      <div>Success</div>
    )
  }
  

  const handleSubmit = () => {
    // We are performing some simple validation here.
    // I highly recommend checking a fully-fledged solution
    // for forms like https://react-hook-form.com/
    if (form.email === '' ) return

    subscribe({
      FNAME:form.firstName,
      LNAME:form.lastName,
      EMAIL:form.email
  })
  }

  if (status === Status.loading) {
    return <Loading />
  }

  if (status === Status.error) {
    return <Error error={error}/>
  }

  if (value) {
    return <Success />
  }

  return (
    <form>
      <Typography variant='h5'>{t('common:LABEL_NEWSLETTER_SUBSCRIBE')}</Typography>
       <Table size="small" aria-label="a dense table">
        <TableBody>
        
        <TableRow key='fn'>
        <TableCell sx={DateCellStyling}>
        <label htmlFor="firstName">{t('common:LABEL_FIRST_NAME')}:</label>
        </TableCell>
        <TableCell sx={ContentCellStyling}>
          <input
            id="firstName"
            value={form.firstName}
            onChange={handleInputChange}
          />
        </TableCell>
        </TableRow>

        <TableRow key='ln'>
          <TableCell sx={DateCellStyling}>
            <label htmlFor="lastName">{t('common:LABEL_LAST_NAME')}:</label>
          </TableCell>
          <TableCell sx={ContentCellStyling}>
            <input
              id="lastName"
              value={form.lastName}
              onChange={handleInputChange}
            />
          </TableCell>
        </TableRow>

        <TableRow key='em'>
          <TableCell sx={DateCellStyling}>
            <label htmlFor="email">Email:*</label>
          </TableCell>
          <TableCell sx={ContentCellStyling}>
            <input 
              id="email" 
              value={form.email} 
              onChange={handleInputChange} 
            />
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell sx={DateCellStyling}></TableCell>
          <TableCell sx={ContentCellStyling}>
            <button onClick={handleSubmit}>Subscribe 📨</button>
          </TableCell>
        </TableRow>
        </TableBody>
      </Table>
    </form>
  )
}